import { useCallback } from 'react';

import { useUser } from './useUser';
import { useGetGuest } from './useGetGuest';

/**
 *
 */
export function useGetGuestOrUser() {
  const [user] = useUser();
  const [getGuest, { isLoading }] = useGetGuest();

  const getGuestOrUser = useCallback(async () => {
    try {
      if (user) return user;

      return getGuest();
    } catch (err) {
      return null;
    }
  }, [user]);

  return [getGuestOrUser, { isLoading }] as const;
}
